import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/privacy-policy")({
  head: () => {
    const title = `Privacy Policy — ${siteConfig.siteName}`;
    const desc = `How ${siteConfig.siteName} collects, uses, and protects your personal information.`;
    const url = `${siteConfig.domain}/privacy-policy`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: Privacy,
});

function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-4xl font-bold tracking-tight">Privacy Policy</h1>
        <div className="prose-article mt-6">
          <p>
            This Privacy Policy explains how {siteConfig.siteName} ("we", "us")
            collects, uses, and shares information when you visit our website.
            By using the site, you agree to the practices described below.
          </p>
          <h2>Information we collect</h2>
          <p>
            We collect standard log data (IP address, browser, pages viewed) via
            analytics tools such as Google Analytics. We also collect information
            you submit voluntarily — for example, when you contact us by email.
          </p>
          <h2>How we use information</h2>
          <p>
            We use collected information to operate the site, improve content,
            respond to inquiries, and measure the performance of our editorial
            work. We do not sell personal information.
          </p>
          <h2>Advertising and cookies</h2>
          <p>
            We use Google AdSense to display advertising on this site. Google and
            its partners may use cookies to serve ads based on your visits to
            this site and other sites on the internet. You may opt out of
            personalized advertising at{" "}
            <a href="https://www.google.com/settings/ads">
              google.com/settings/ads
            </a>
            .
          </p>
          <h2>Third-party services</h2>
          <p>
            We use third-party services (analytics, advertising, embedded
            content) that may collect information about you. These services have
            their own privacy policies.
          </p>
          <h2>Your rights</h2>
          <p>
            Depending on your jurisdiction, you may have rights to access,
            correct, or delete personal information we hold about you. To
            exercise these rights, email{" "}
            <a href={`mailto:${siteConfig.contactEmail}`}>
              {siteConfig.contactEmail}
            </a>
            .
          </p>
          <h2>Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Material changes
            will be reflected on this page with a new effective date.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
